import React from 'react';
import type { ReportAppProps } from '@atlassian/jira-servicedesk-reports-common/src/ui/date-filter/types';
import useReportsController from './controllers';
import KbRequestsReportsView from './ui';

export const KbRequestsReportsMain = (props: ReportAppProps) => {
	const resources = useReportsController(props);
	// @ts-expect-error - TS2322 - Type '{ summaryResource: Provider<ChartData>; drilldownResource: Provider<RequestsResponse>; baseUrl: string; projectKey: string; routerProps: RouterProps; intl: IntlShapeV2; }' is not assignable to type 'CommonProps'.
	return <KbRequestsReportsView {...props} {...resources} />;
};
